import React from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Slider } from "@/uiKit/atoms/inputs/Slider.tsx";

export type LibreviewGroupedInclusionTIRFilterProps = {
  value: number;
  onValueChange: (value: number) => void;
  className?: string;
};

export const LibreviewGroupedInclusionTIRFilter: React.FC<LibreviewGroupedInclusionTIRFilterProps> = ({
  value,
  onValueChange,
  className,
}) => {
  const styles = useStyles(makeStyles);

  return (
    <Slider
      id="sync-grouped-inclusion-tir-filter"
      min={40}
      max={100}
      step={5}
      value={value}
      marks={[40, 70, 100].map(v => ({ value: v, label: v }))}
      onChange={value => {
        onValueChange(value);
      }}
      valueLabelDisplay="auto"
      className={cx(styles.slider, className)}
    />
  );
};

// Hide the tick dots (.MuiSlider-mark) but keep the value captions (.MuiSlider-markLabel).
const makeStyles = () => ({
  slider: css({
    "& .MuiSlider-mark": {
      display: "none",
    },
  }),
});
